var path = require('../internals/path');

module.exports = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/entry-virtual.js
// module id = 51
// module chunks = 0 7 8 9 10 11